import { useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { staffTransfers, type StaffTransfer } from '@/api/hr';
import DataTable, { type ColumnDef } from '@/shared/components/DataTable';

const fmt2 = (v: string | number) =>
  Number(v).toLocaleString('uk-UA', { minimumFractionDigits: 2, maximumFractionDigits: 2 });

export default function StaffTransfersPage() {
  const navigate = useNavigate();
  const list = useQuery({
    queryKey: ['staff-transfers'],
    queryFn: () => staffTransfers.list({ limit: 200 }),
  });

  const cols = useMemo<ColumnDef<StaffTransfer>[]>(() => [
    { key: 'document_number', header: '№', width: 130, importBadge: true, sortValue: (r) => r.document_number ?? '', cell: (r) => r.document_number },
    {
      key: 'document_date', header: 'Дата', width: 160,
      sortValue: (r) => r.document_date ?? '',
      cell: (r) => r.document_date ? new Date(r.document_date).toLocaleString('uk-UA') : '',
    },
    {
      key: 'transfer_date', header: 'Перевести з', width: 130,
      sortValue: (r) => r.transfer_date ?? '',
      cell: (r) => r.transfer_date ? new Date(r.transfer_date).toLocaleDateString('uk-UA') : '',
    },
    {
      key: 'new_salary_amount', header: 'Новий оклад', width: 140, align: 'right',
      sortValue: (r) => Number(r.new_salary_amount),
      cell: (r) => fmt2(r.new_salary_amount),
    },
    {
      key: 'posted', header: 'Проведено', width: 120, align: 'center',
      sortValue: (r) => r.posted ? 1 : 0,
      cell: (r) => r.posted ? '✓ так' : 'ні',
    },
  ], []);

  return (
    <>
      <div className="toolbar">
        <h2 style={{ margin: 0 }}>Кадрові переміщення</h2>
        <button className="primary" onClick={() => navigate('/staff-transfers/new')}>
          + Нове переміщення
        </button>
      </div>
      <DataTable<StaffTransfer>
        rows={list.data?.items ?? []}
        columns={cols}
        rowKey={(r) => r.id}
        loading={list.isLoading}
        emptyText="Немає документів."
        onRowDoubleClick={(r) => navigate(`/staff-transfers/${r.id}`)}
        rowMuted={(r) => r.deletion_mark ? 0.4 : undefined}
        initialSortKey="document_date"
        initialSortDir="desc"
      />
    </>
  );
}
